import React from "react";


const useAccommodationUnitSelector = (accommodationUnits) => {
    const [innerSelectedUnit, setSelectedUnit] = React.useState(null);
    const selectedUnit = innerSelectedUnit || accommodationUnits?.[0] || null;

    const selectNext = () => {
        if(selectedUnit === null || !Array.isArray(accommodationUnits)) {
            return;
        }
        const selectedIndex = accommodationUnits?.findIndex(apartment => apartment.id === selectedUnit?.id);
        if (selectedIndex < accommodationUnits.length - 1) {
            setSelectedUnit(accommodationUnits[selectedIndex + 1]);
        }else{
            setSelectedUnit(accommodationUnits[0]);
        }
    }

    const selectPrev = () => {
        if(selectedUnit === null || !Array.isArray(accommodationUnits)) {
            return;
        }
        const selectedIndex = accommodationUnits.findIndex(apartment => apartment.id === selectedUnit?.id);
        if (selectedIndex > 0) {
            setSelectedUnit(accommodationUnits[selectedIndex - 1]);
        }else{
            setSelectedUnit(accommodationUnits[accommodationUnits.length - 1]);
        }
    }

    return {
        selectedAccommodationUnit: selectedUnit,
        handleChange: setSelectedUnit,
        selectNext,
        selectPrev
    }
}

export default useAccommodationUnitSelector;